import { Layout, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { goToWorkspace } from 'utilities/workspace';

import WorkspaceLogo from 'components/workspace-logo';

import styles from './styles.module.less';

const WorkspaceList = ({
  selectedWorkspace,
  hideSections = false,
  logoSize = 4,
}) => {
  const workspaces = useSelector(state => state.workspace.workspaces);
  const filteredWorkspaces = workspaces.filter(
    workspace => workspace.id !== selectedWorkspace.id
  );

  if (!filteredWorkspaces.length) {
    return null;
  }

  return (
    <div className={hideSections ? null : styles.workspacesListSection}>
      {filteredWorkspaces.map((workspace, index) => {
        const membersCopy = workspace.members > 1 ? 'members' : 'member';

        return (
          <a
            href="#"
            className={styles.workspaceItem}
            key={index}
            onClick={e => {
              e.preventDefault();
              goToWorkspace(workspace.id);
            }}
          >
            <Layout gap={1} alignment="center">
              <Layout.Section width="auto">
                <WorkspaceLogo size={logoSize} workspace={workspace} />
              </Layout.Section>
              <Layout.Section className={styles.workspaceInfoSection}>
                <Text hasEllipsis fontWeight="bold">
                  {workspace.name}
                </Text>
                <Text hasEllipsis size="small" color="bodyDimmed">
                  {workspace.members} {membersCopy}
                </Text>
              </Layout.Section>
            </Layout>
          </a>
        );
      })}
    </div>
  );
};

export default WorkspaceList;
